export default "__VITE_ASSET__24WURnNJ__"